module.exports = __webpack_public_path__ + "img/closed-loop-6.d71348eb.png";